// extracted by mini-css-extract-plugin
module.exports = {"check":"styles_check__N7-2_"};